export const Email = {
    path: '/emails',
    name: 'emails',
    component: () => import('@/views/Email/EmailPage.vue'),
    children: [
        {
            path: '/emails/add',
            name: 'emails.add',
            component: () => import('@/views/Email/Form/EmailForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/emails/edit/:id',
            name: 'emails.edit',
            component: () => import('@/views/Email/Form/EmailForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/emails/delete/:id',
            name: 'emails.delete',
            component: () => import('@/views/Email/Form/EmailForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/emails/view/:id',
            name: 'emails.view',
            component: () => import('@/views/Email/Form/EmailForm.vue'),
            props: {viewAction: true}
        },
    ],
}
